import { useParams, useNavigate, Navigate } from "react-router";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { TournamentContextProvider, useTournamentContext } from "../../context/TournamentContext";
import TournamentLesson from "./Components/TournamentLesson";
import { hasTournamentStarted } from "./tournamentUtil";

// Exercises are only reachable once the tournament has started. The tournament page disables the buttons,
// but the content route can still be hit directly via a email and such so gate it here too.
function TournamentContent({
  tournamentId,
  onContentComplete,
}: {
  tournamentId: string;
  onContentComplete: () => void;
}) {
  const { content } = useTournamentContext();
  const startDate = content?.tournament?.startDate;

  if (startDate && !hasTournamentStarted(startDate)) {
    return (
      <Navigate
        to={buildRoute("Learn.routes.tournaments.routes.details.route", { tournamentId })}
        replace
      />
    );
  }

  return <TournamentLesson onContentComplete={onContentComplete} />;
}

export default function TournamentContentPage() {
  const { tournamentId, contentType, contentId } = useParams();

  const navigate = useNavigate();

  if (!tournamentId) return null;

  const validContentType =
    contentType === "Lesson" || contentType === "Experiment" ? contentType : undefined;

  if (!contentId || !validContentType) return null;

  const onContentComplete = () => {
    navigate(buildRoute("Learn.routes.tournaments.routes.details.route", { tournamentId }));
  };

  return (
    <TournamentContextProvider
      tournamentId={tournamentId}
      contentType={validContentType}
      contentId={contentId}
    >
      <div
        className="h-full"
        aria-label="Tournament Lesson Content"
        data-testid="tournament-content-page"
      >
        <TournamentContent tournamentId={tournamentId} onContentComplete={onContentComplete} />
      </div>
    </TournamentContextProvider>
  );
}
